import { pGetAll } from '@/api/parametre/';
import * as types from './regleFacturation-mutation-type';
import { RESET_STATE } from '../../mutation-type';
import { PARAMETRES_KEYS } from '../parametres-mutation-type';

function initialState() {
  return {
    items: [],
    totalCount: 0,
    filter: '',
    regleFacturationCourante: null,
  };
}

const state = initialState();

const namespaced = true;

const mutations = {
  [types.SET_ITEMS](state, items) {
    state.items = items;
  },
  [types.SET_TOTAL](state, totalCount) {
    state.totalCount = totalCount;
  },
  [types.SET_FILTER](state, filter) {
    state.filter = filter;
  },
  [types.SET_REGLE_FACTURATION_COURANTE](state, regleFacturationCourante) {
    state.regleFacturationCourante = regleFacturationCourante;
  },
  [RESET_STATE](state) {
    const s = initialState();
    Object.keys(state).forEach(key => {
      state[key] = s[key];
    });
  },
};

const actions = {
  async loadRegleFacturation({ commit }, data = {}) {
    const result = (await pGetAll(PARAMETRES_KEYS.regleFacturation, data)).data.result;
    commit(types.SET_ITEMS, result.items);
    commit(types.SET_TOTAL, result.totalCount);
    return {
      data: result.items,
      count: result.totalCount,
    };
  },
};

const getters = {
  items: state => {
    return state.items;
  },
  totalCount: state => {
    return state.totalCount;
  },
  filter: state => {
    return state.filter;
  },
  regleFacturationCourante: state => {
    return state.regleFacturationCourante;
  },
};

export default {
  namespaced,
  state,
  mutations,
  actions,
  getters,
};
